import { lazy } from 'react';

import { PATHS } from './constants';

const MyProfile = lazy(() => import('./screens/MyProfile'));

const routes = [
  {
    component: MyProfile,
    path: PATHS.BASE,
    exact: false,
    onOrgChangeRedirectTo: '/:orgId/-/user/profile',
  },
];

export default routes;
